<template>
  <div class="relative h-32" :class="{ 'inline-block': fitContent }">
    <span
      v-if="fitContent"
      class="invisible block whitespace-nowrap type-headline-sm pr-32"
      :class="selectClass"
      aria-hidden="true"
    >{{ options.find(item => item.value === model)?.label }}</span>
    <select
      v-model="model"
      class="h-full w-full text-end bg-lightest type-headline-sm cursor-pointer pr-32"
      :class="[selectClass, {
        'absolute inset-0 pl-0': fitContent,
        'text-end': textAlign === 'end',
        'text-start': textAlign !== 'end',
      }]"
      @change="(e) => $emit('change', e.target.value)"
    >
      <option
        v-for="item in options"
        :key="`dropdown-status-item-${item.value}`"
        :value="item.value"
      >
        {{ item.label }}
      </option>
    </select>
    <div
      class="absolute w-32 bg-lightest pointer-events-none top-0 right-0 bottom-0 flex justify-center items-center"
    >
      <img
        src="/icons/angle-right.svg"
        class="inline-block w-16 h-16 rotate-90"
      >
    </div>
  </div>
</template>

<script lang="ts" setup>
const model = defineModel<string>();
defineProps<{
  options: { label: string; value: string }[];
  textAlign?: 'start' | 'end';
  selectClass?:string;
  fitContent?: boolean;
}>();

defineEmits<{
  (e: 'change', payload: string): void;
}>();
</script>
